import React from 'react';

import Icon, { Props } from './icon';

export const PlayCircleOutlinedIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props}>
      <path d="M16.518 4.213c1.382.797 2.475 1.887 3.278 3.27C20.599 8.864 21 10.37 21 12c0 1.629-.401 3.135-1.204 4.518-.803 1.382-1.896 2.475-3.278 3.278C15.135 20.599 13.628 21 12 21c-1.629 0-3.135-.401-4.518-1.204-1.382-.803-2.475-1.896-3.278-3.278C3.401 15.135 3 13.628 3 12c0-1.629.401-3.135 1.204-4.518C5.007 6.1 6.1 5.007 7.482 4.204 8.865 3.401 10.372 3 12 3c1.629 0 3.135.404 4.518 1.213zm1.095 13.4c.734-.734 1.305-1.576 1.715-2.527.409-.974.613-2.003.613-3.086 0-1.083-.21-2.112-.632-3.086-.397-.95-.962-1.793-1.696-2.527-.734-.734-1.576-1.305-2.527-1.715-.974-.409-2.003-.613-3.086-.613-1.083 0-2.112.21-3.086.632-.95.397-1.793.962-2.527 1.696-.734.734-1.305 1.576-1.715 2.527-.409.974-.613 2.003-.613 3.086 0 1.083.21 2.112.632 3.086.397.95.962 1.793 1.696 2.527.734.734 1.576 1.305 2.527 1.715.974.409 2.003.613 3.086.613 1.083 0 2.112-.21 3.086-.632.95-.397 1.793-.962 2.527-1.696z" />
      <path
        d="M13.568 9.277l3.323 4.614c.226.314.155.751-.16.977-.118.086-.261.132-.408.132H9.677c-.386 0-.7-.313-.7-.7 0-.147.046-.29.132-.41l3.323-4.613c.226-.314.663-.385.977-.16.061.045.115.098.159.16z"
        transform="rotate(90 13 12)"
      />
    </Icon>
  );
};

export default React.memo(PlayCircleOutlinedIcon);
